
import { Button } from "@/components/ui/button";
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";

interface InvalidTokenCardProps {
  errorMessage: string | null;
  onNavigateToLogin: () => void;
}

export function InvalidTokenCard({ errorMessage, onNavigateToLogin }: InvalidTokenCardProps) {
  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle className="text-2xl text-center">Lien invalide</CardTitle>
        <CardDescription className="text-center">
          {errorMessage || "Le lien de réinitialisation est invalide ou a expiré."}
        </CardDescription>
      </CardHeader>
      <CardFooter className="flex justify-center">
        <Button onClick={onNavigateToLogin}>
          Retour à la page de connexion
        </Button>
      </CardFooter>
    </Card>
  );
}
